import React, { useState, useRef, useEffect, useCallback } from "react";
import 'ag-grid-enterprise';
import AgGridTable from "../utilities/AgGridTable";
import Select from "react-select";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Autocomplete, Button, FormControlLabel, Grid, Radio, RadioGroup, Stack, TextField } from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import moment from 'moment';
import AgCharts from "../utilities/AgCharts";
import NotificationCard from "./NotificationCard";
import Calendar from "./Calendar";
import CustomCalendar from "./CustomCalender";

const pendingLeaveData = [
    { month: 'Jan', leave: 12 },
    { month: 'Feb', leave: 4 },
    { month: 'March', leave: 5 },
    { month: 'Apr', leave: 7 },
    { month: 'May', leave: 8 },
    { month: 'Jun', leave: 3 },
    { month: 'Jul', leave: 5 },
    { month: 'August', leave: 6 },
]
const leaveSummaryData = [
    { month: 'Jan', Forecast: 10, Processed: 9 },
    { month: 'Feb', Forecast: 6, Processed: 9 },
    { month: 'March', Forecast: 4, Processed: 5 },
    { month: 'Apr', Forecast: 7, Processed: 6 },
    { month: 'May', Forecast: 6, Processed: 3 },
    { month: 'August', Forecast: 2, Processed: 5 },
]
const dueDaysData = [
    { month: 'Jan', dueDays: 12 },
    { month: 'Apr', dueDays: 7 },
    { month: 'May', dueDays: 8 },
    { month: 'Jun', dueDays: 3 },
    { month: 'Jul', dueDays: 5 },
    { month: 'August', dueDays: 6 },
]

const penddingLeaveColumn = [
    { field: 'month', enableRowGroup: true, },
    { field: 'leave', enableRowGroup: true, },
]
const leaveSummaryColumn = [
    { field: 'month', enableRowGroup: true, },
    { field: 'Forecast', enableRowGroup: true, },
    { field: 'Processed', enableRowGroup: true, },
]
const dueDaysColumn = [
    { field: 'month', enableRowGroup: true, },
    { field: 'dueDays', enableRowGroup: true, },
]


const gridOption = [{ label: "Pending Leave" }, { label: "Leave Summary" }, { label: "Due Days" }];

const AttendanceManagement = () => {
    const [columnDefs, setColumnDefs] = useState(penddingLeaveColumn);
    const [rowData ,  setRowData]= useState();
    const [selectGrid, setSelectGrid] = useState("");

    const handleGridChange = (data)=>{
        setSelectGrid(data.label)
    }
    useEffect(()=>{
        if(selectGrid === 'Pending Leave'){
            setColumnDefs(penddingLeaveColumn);
            setRowData(pendingLeaveData);
        }else if(selectGrid === 'Leave Summary'){
            setColumnDefs(leaveSummaryColumn);
            setRowData(leaveSummaryData);
        }else if(selectGrid === 'Due Days'){
            setColumnDefs(dueDaysColumn);
            setRowData(dueDaysData);
        }
    }, [selectGrid,columnDefs, rowData])

    return (
        <>
            <ListPageHeader
                componentName="Attendance Management"
                pageName="Attendance Management"
                pagination={false}
            />
            <Grid container spacing={2}>
                <Grid item xs={5}>
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <NotificationCard />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} >
                        <Grid item xs={12}>
                            <div className="mr-16 flex justify-end">
                                <Stack>
                                    <label>Select grid</label>
                                    <Select
                                        className="w-[200px]"
                                        name="grid"
                                        value={(selectGrid && gridOption) && gridOption.filter(obj => selectGrid === obj.label)}
                                        onChange={handleGridChange}
                                        options={gridOption}
                                        styles={customStyles()}
                                    />
                                </Stack>
                            </div>
                            <div className="h-full p-16" style={{ height: "450px" }}>
                                <AgGridTable
                                    // ref={gridRef}
                                    rowData={pendingLeaveData}
                                    columnDefs={columnDefs}
                                    hideCheckbox={true}
                                    suppressRowCount={true}
                                // defaultColDef={defaultColDef}
                                // onGridReady={onGridReady}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={7}>
                    <CustomCalendar />
                </Grid>

            </Grid>

        </>
    )
}

export default AttendanceManagement